/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-10-08 16:21:24
 */
export default {
  lang: "英语",
  landing: {
    name1: "Carlcare ਖੋਲ੍ਹੋ",
    name2: "ਰਿਜ਼ਰਵ ਕਰੋ",
    name3: "Carlcare ਨਾਲ ਤੁਸੀਂ ਕਿਸੇ ਵੀ ਵੇਲੇ ਆਪਣੇ ਆਰਡਰ ਚੈੱਕ ਕਰ ਸਕਦੇ ਹੋ।",
    name4: "",
    name5: "ਸੱਜੇ ਪਾਸੇ ਸਲਾਈਡ ਕਰੋ",
    name6: "ਪੁਸ਼ਟੀਕਰਨ ਪੂਰਾ ਹੋ ਗਿਆ",
  },
  order: {
    name1: "ਡਿਵਾਈਸ ਮਾਡਲ ਚੁਣੋ",
    name2: "ਨੁਕਸ ਵਰਣਨ:",
    name3: "ਸੇਵਾ ਸਟੋਰ ਚੁਣਨ ਲਈ ਛੂਹੋ",
    name4: "ਸੇਵਾ ਸਟੋਰ:",
    name5: "ਰਿਜ਼ਰਵੇਸ਼ਨ ਦਾ ਸਮਾਂ:",
    name6: "ਆਪਣੇ ਡਿਵਾਈਸ ਦੀ ਸਮੱਸਿਆ ਬਾਰੇ ਵੇਰਵੇ ਨਾਲ ਦੱਸੋ ਜੀ!",
    name7: "ਪਹੁੰਚਣ ਦੇ ਸਮੇਂ ਨੂੰ ਛੂਹੋ",
    name8: "ਆਪਣੇ ਠੀਕ ਸੰਪਰਕ ਵੇਰਵੇ ਦਿਓ ਤਾਂ ਕਿ ਅਸੀਂ ਤੁਹਾਡੇ ਨਾਲ ਸੰਪਰਕ ਕਰ ਸਕੀਏ",
    name9: "ਮੌਜੂਦਾ ਰਿਜ਼ਰਵੇਸ਼ਨ ਸਮੇਂ ਅੱਗੇ ਦਿੱਤੇ ਹਨ",
    name10: "ਆਪਣੇ ਫੋਨ ਨੰਬਰ ਦਰਜ ਕਰੋ",
    name11: "ਕੀਮਤ",
    name12: "ਨਿੱਜੀ ਜਾਣਕਾਰੀ:",
    name13: "ਕਿਰਪਾ ਕਰਕੇ ਆਪਣਾ ਨਾਂ ਦਰਜ ਕਰੋ",
    name14: "ਭੇਜੋ",
    name15: "ਰੱਦ ਕਰੋ",
    name16: "ਠੀਕ ਹੈ",
  },
  shops: {
    name1: "ਤੁਹਾਡੇ ਵਲੋਂ ਚੁਣੇ ਬਰੈਡ ਦੇ ਅਧਾਰ ਉੱਤੇ ਅੱਗੇ ਦਿੱਤੇ ਸਤੋਰ ਤੁਹਾਨੂੰ ਸੇਵਾ ਦੇ ਸਕਦੇ ਹਨ!",
    name2: "ਹੋਰ ਰਿਟੇਲ ਸਟੋਰ ਛੇਤੀ ਹੀ ਆ ਰਹੇ ਹਨ! ਸਾਡੇ ਨਾਲ ਜੁੜੇ ਰਹੋ!",
  },
  price: {
    name1: "ਬਰਾਂਡ",
    name2: "ਮਾਡਲ",
    name3: "ਆਈਟਮ",
    name4: "ਕੀਮਤ",
    name5: "ਦੋਸਤਾਨਾ ਤਾਕੀਦ:",
    name6: "ਇਹ ਕੀਮਤਾਂ ਸਿਰਫ਼ ਹਵਾਲੇ ਲਈ ਹਨ ਅਤੇ ਅਸਲ ਕੀਮਤ ਤੁਹਾਡੇ ਡਿਵਾਈਸ ਦੀ ਹਾਲਤ ਉੱਤੇ ਨਿਰਭਰ ਹੈ।",
    name7: "ਜੇ ਕੋਈ ਖਾਸ ਚਿੰਨ੍ਹ ਨਹੀਂ ਹੈ ਤਾਂ ਕੀਮਤ ਦੀ ਇਕਾਈ ਲੋਕਲ ਕਰੰਸੀ ਇਕਾਈ ਹੈ।",
    name8: "ਅਫ਼ਸੋਸ! ਮੌਜੂਦਾ ਖੇਤਰ ‘ਚ ਕੋਈ ਕੀਮਤ ਜਾਣਕਾਰੀ ਉਪਲੱਬਧ ਨਹੀਂ ਹੈ।",
    name11:"ਲੇਬਰ ਦੀ ਲਾਗਤ",
    name12:"ਕੁੱਲ ਕੀਮਤ",
    name13: "5. ਜੇ ਲੇਬਰ ਦੀ ਲਾਗਤ \"/\" ਹੈ, ਤਾਂ ਇਸ ਦਾ ਮਤਲਬ ਇਹ ਹੈ ਕਿ ਲੇਬਰ ਦੀ ਲਾਗਤ ਬਾਰੇ ਸਟੋਰ ਨਾਲ ਸਲਾਹ-ਮਸ਼ਵਰਾ ਕਰਨ ਦੀ ਲੋੜ ਹੈ।",
    item_main_board: "ਮਦਰਬੋਰਡ",
    item_screen_frame: "ਸਕਰੀਨ (ਫ੍ਰੇਮ)",
    item_screen_screen_frame: "ਸੈਕੰਡਰੀ ਸਕਰੀਨ (ਫ੍ਰੇਮ)",
    item_touch_screen: "ਟੱਚ ਸਕਰੀਨ",
    item_camera: "\"ਕੈਮਰਾ\"",
    item_fixed_focus_camera: "ਫਿਕਸਡ ਫੋਕਸ ਕੈਮਰਾ",
    item_auto_focus_camera: "ਆਟੋ ਫੋਕਸ ਕੈਮਰਾ",
    item_screen: "ਸਕਰੀਨ",
    item_secondary_screen: "ਸੈਕੰਡਰੀ ਸਕਰੀਨ",
    item_fingerprint_module: "ਫਿੰਗਰਪ੍ਰਿੰਟ ਮਾਡਿਊਲ",
    item_speaker: "ਸਪੀਕਰ",
    item_receiver: "ਰਿਸੀਵਰ",
    item_small_board: "ਛੋਟਾ ਬੋਰਡ",
    item_battery_cover: "ਬੈਟਰੀ ਕਵਰ",
    item_battery: "ਬੈਟਰੀ",
    item_charger: "ਚਾਰਜਰ",
    item_usb_cable: "USB ਕੇਬਲ",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "ਕੋਈ ਡਾਟਾ",
    name2: "ਸਰਵਿਸ ਪੂਰਕ:",
    name3: "ਸੇਵਾ ਬਰੈਂਡ:",
    name4: "ਟੈਲੀਫ਼ੋਨ:",
    name5: "ਆਰਡਰ ਦੀ ਮਾਤਰਾ:",
    name6: "ਸੇਵਾ ਰੇਟਿੰਗ:",
    name7: "ਸੇਵਾ ਇੰਵਾਇਰਨਮੈਂਟ",
    name8: "ਸੇਵਾ ਵਿਹਾਰ:",
    name9: "ਸੇਵਾ ਕਾਰਗੁਜ਼ਾਰੀ:",
    name10: "ਸੇਵਾ ਦੀ ਕੁਆਲਟੀ:",
    name11: "ਗਾਹਕ ਦਾ ਮੁਲਾਂਕਣ",
    name12:"ਤੋਂ",
    name13:"ਬੰਦ ਕੀਤਾ",
  },
  reserSuccess: {
    // name1:
    //   "Carlcare ਖੋਲ੍ਹੋ",
    name1: "ਰਿਜ਼ਰਵੇਸ਼ਨ ਦੀ ਜਾਣਕਾਰੀ ਦਾ ਸਕਰੀਨਸ਼ਾਟ ਲਵੋ ਤੇ ਇਸ ਨੂੰ ਤਰਜੀਹੀ ਸੇਵਾ ਲਈ ਪਹੁੰਚ ਵਾਸਤੇ ਰਸੀਦ ਵਜੋਂ ਸੰਭਾਲੋ।",
    name2: "ਕਾਮਯਾਬੀ ਨਾਲ ਭੇਜਿਆ",
    name3: "1. ਡਾਟਾ ਮਿਟਾਓ",
    name4: "ਆਪਣੇ ਫ਼ੋਨ ‘ਤੇ ਖ਼ਾਸ ਪ੍ਰਾਈਵੇਟ ਡਾਟੇ ਦਾ ਬੈਕਅੱਪ ਪਹਿਲਾਂ ਹੀ ਲੈ ਲਵੋ",
    name5: "2. ਸ਼ੁਰੂ ਵੇਲੇ ਦਾ ਪਾਸਵਰਡ ਅਸਮਰੱਥ ਕਰੋ",
    name6: "ਸੇਵਾ ਸਟੋਰ ‘ਤੇ ਜਾਣ ਤੋਂ ਪਹਿਲਾਂ, ਕਿਰਪਾ ਕਰਕੇ:",
    name7: "ਸੇਵਾ ਸਟੋਰ:",
    name8: "ਰਿਜ਼ਰਵੇਸ਼ਨ ਦਾ ਸਮਾਂ:",
    name9: "ਨੁਕਸ ਵਰਣਨ:",
    name10: "ਡਿਵਾਈਸ ਮਾਡਲ:",
    name11: "ਆਰਡਰ ਨੰਬਰ:",
    name12: "ਆਰਡਰ ਦੀ ਜਾਣਕਾਰੀ",
  },
  title: {
    
    name1: "ਅੱਗੇ ਦਿੱਤੇ ਦੇਸ਼ਾਂ ਲਈ ਸਹਇਕ ਹੈ:",
    name2: "ਮਾਡਲ ਚੁਣੋ",
    name3: "ਰਾਖਵਾਂਕਰਨ",
    name4: "ਸੇਵਾ ਸਟੋਰ ਦੇ ਵੇਰਵੇ",
    name5: "ਸੇਵਾ ਸਟੋਰ ਨੂੰ ਚੁਣੋ",
  },
  error: {
    
    name1: "ਕੋਈ ਡਾਟਾ ਨਹੀਂ। ਆਪਣੀ ਰਿਪੇਅਰ ਜਾਣਕਾਰੀ ਦੀ ਜਾਂਚ ਕਰੋ",
    name2: "ਹੋਰ ਮਦਦ ਚਾਹੀਦੀ ਹੈ? ਸਾਡੇ ਨਾਲ ਸੰਪਰਕ ਕਰੋ।",
    name3: "ਅਫਸੋਸ, ਇਸ ਖੇਤਰ ‘ਚ ਕੋਈ Carlcare ਕੇਂਦਰ ਨਹੀਂ ਹੈ।",
    name4: "ਪਹਿਲਾਂ ਸੇਵਾ ਕੇਂਦਰ ਚੁਣੋ ਜੀ",
    name5: "ਅਸਫ਼ਲ ਹੈ",
    name6: "ਪਹਿਲਾਂ ਡਿਵਾਈਸ ਦਾ ਮਾਡਲ ਚੁਣੋ",
    name7: "ਵੇਰਵੇ",
    name8: "ਆਪਣੀਆਂ ਲੋੜਾਂ ਬਾਰੇ ਵੇਰਵੇ ‘ਚ ਵਰਣਨ ਕਰੋ",
    name9: "",
  },
  add1:{
    "name0": "pa-rIN",
    "name1": "ਤੁਹਾਡੇ ਆਰਡਰ ਦੀ ਪੁਸ਼ਟੀ ਹੋ ਗਈ ਹੈ। ਅਸੀਂ ਤੁਹਾਡੇ ਪਹੁੰਚਣ ਦੀ ਉਡੀਕ ਕਰ ਰਹੇ ਹਾਂ।",
    "name2": "ਸ਼ਹਿਰ ਚੁਣੋ",
    "name3": "ਕਿਰਪਾ ਕਰਕੇ %1$s ਅੰਕਾਂ ਦਾ ਫ਼ੋਨ ਨੰਬਰ ਦਰਜ ਕਰੋ।",
    "name4": "ਹਫ਼ਤੇ ਦੇ ਦਿਨ ਦੇ ਘੰਟੇ",
    "name5": "ਸੋਮਵਾਰ",
    "name6": "ਮੰਗਲਵਾਰ",
    "name7": "ਬੁੱਧਵਾਰ",
    "name8": "ਵੀਰਵਾਰ",
    "name9": "ਸ਼ੁੱਕਰਵਾਰ",
    "name10": "ਸ਼ਨਿਚਰਵਾਰ",
    "name11": "ਐਤਵਾਰ",
    "name12": "ਦੇਸ਼ ਦਾ ਨਾਮ ਦਰਜ ਕਰੋ ਅਤੇ ਖੋਜੋ"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "pick-up time",
    "name7": "tap to select pick-up time",
    "name8": "pick-up address",
    "name9": "Pleasee input your house number/street/district/province",
    "name10": "Pleasee input postal code",
    "name11": "Add returning address",
    "name12": "returning address",
    "name13": "ਹੋਰ",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
  },
  coupons: {
    name1:"Coupons",
    name2:"ਰੀਡਾਇਰੈਕਟ ਕਰਨ ਲਈ ਟੈਪ ਕਰੋ",
    name3:"ਆਰਡਰ ਨੂੰ ਰੇਟ ਕਰਨ ਲਈ Carlcare ਐਪ ਨੂੰ ਖੋਲ੍ਹੋ",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"ਸੇਵਾ ਚੁਣੋ",
    name7:"ਮੁਫ਼ਤ ਸਫਾਈ",
    name8:"Software Upgrade",
  },
  cancelorder:{
    "cancelReason0": "ਗਲਤ ਜਾਣਕਾਰੀ",
    "cancelReason1": "ਸਮੇਂ ਸਿਰ ਨਹੀਂ ਪਹੁੰਚ ਸਕਦੇ",
    "cancelReason2": "ਡੁਪਲੀਕੇਟ ਆਰਡਰ/ਮੇਰਾ ਆਰਡਰ ਨਹੀਂ ਹੈ",
    "cancelReason3": "ਅਸਫਲਤਾ ਦੁਬਾਰਾ ਨਹੀਂ ਆਈ",
    "cancelReason4": "ਸਿਰਫ਼ ਟੈਸਟ/ਪੁੱਛਗਿੱਛ/ਇਵੈਂਟ/…",
    "cancelReason5": "ਉੱਚ ਕੀਮਤ",
    "cancelReason6": "ਸਮਾਨ ਦੀ ਕਮੀ",
    "cancelReason7": "ਕੋਈ ਵੱਖਰੀਆਂ ਸੇਵਾਵਾਂ ਨਹੀਂ ਹਨ",
    "cancelReason8": "ਸਟੋਰ ਬਹੁਤ ਦੂਰ ਹੈ",
    "cancelReason9": "ਸਟੋਰ ਬੰਦ ਹੈ",
    "cancelReason10": "ਸਰਵਿਸ ਵਾਲਿਆਂ ਦਾ ਮਾੜਾ ਰਵੱਈਆ",
    "cancelReason11": "ਹੋਰ ਬ੍ਰਾਂਡਾਂ ਲਈ ਰਿਪਲੇਸਮੈਂਟ/ਮੁਰੰਮਤ",
    "cancelReason12": "ਸਟੋਰ ਨਹੀਂ ਲੱਭਿਆ",
    "cancelReason13": "ਹੋਰ",
    "cancelOrder": "ਆਰਡਰ ਰੱਦ ਕਰੋ",
    "reason_dialog_title": "ਕਿਰਪਾ ਕਰਕੇ ਸਾਨੂੰ ਰੱਦ ਕਰਨ ਦਾ ਕਾਰਨ ਦੱਸੋ",
    "Cancel": "ਰੱਦ ਕਰੋ",
    "OK": "ਠੀਕ",
    "name1": "ਤਸਦੀਕ ਕੋਡ ਦਰਜ ਕਰੋ",
    "name2": "ਤਸਦੀਕ ਕੋਡ ਅਵੈਧ ਹੈ",
    "repair_reservation_detail_canceled": "ਇਹ ਆਰਡਰ ਰੱਦ ਕੀਤਾ ਜਾ ਚੁੱਕਾ ਹੈ!",
    "purchase_cancel_dialog_content": "ਕੀ ਤੁਸੀਂ ਆਰਡਰ ਰੱਦ ਕਰਨ ਦੀ ਪੁਸ਼ਟੀ ਕਰਦੇ ਹੋ?",
    "yes": "ਹਾਂ",
    "no": "ਨਹੀਂ"
}
};
